import { request } from './index'
import { HTTP_METHODS } from './const'

class Homefeed {
  static getHomefeed(device) {
    return request({
      device,
      url: 'v7/home-feed',
      method: HTTP_METHODS.get,
    })
  }

  static getHomefeedBestSellers() {
    return request({
      url: 'v7/home-feed/best-sellers',
      method: HTTP_METHODS.get,
    })
  }
}

export default Homefeed
